import { useEffect } from 'react';

export function useWeightGroupSelection(subscriptionsDetails, setSubscriptionsDetails, depositedData, currentDog) {
	useEffect(() => {
		if (subscriptionsDetails.length != 0) {
			const currentDogWeight = parseInt(depositedData[currentDog].dogWeight);
			const currentDogWeightUnit = depositedData[currentDog].dogWeightUnit;

			let newSubscriptionsDetails = subscriptionsDetails.map((group) => {
				if (group[currentDogWeightUnit].min <= currentDogWeight && group[currentDogWeightUnit].max >= currentDogWeight) {
					group.selected = true;
				}

				return group;
			});

			if (newSubscriptionsDetails.filter((el) => el.selected === true).length > 1) {
				const firstIndex = newSubscriptionsDetails.find((el) => el.selected === true);
				const lastIndex = newSubscriptionsDetails.reverse().find((el) => el.selected === true);

				if (firstIndex[currentDogWeightUnit].min > lastIndex[currentDogWeightUnit].min) {
					lastIndex.selected = false;
				} else {
					firstIndex.selected = false;
				}
			}

			setSubscriptionsDetails([...newSubscriptionsDetails]);
		}
	}, [depositedData[currentDog]]);
}
